import DataUsageIcon from '@mui/icons-material/DataUsage';
import {Chip, Tooltip} from '@mui/material';
import {array, bool} from 'prop-types';
import React from 'react';
import {useGetProducts} from '@api/products';

const ReservationsChip = ({
  reservationsProductIds = [],
  reservationsProductNames = [],
  showLabel = true,
}) => {
  const {data: products, isLoading} = useGetProducts();

  // this shared component accepts either product names, or product IDs.
  // if reservationsProductNames is provided, we use that.
  const productNames =
    reservationsProductNames?.length > 0
      ? reservationsProductNames
      : reservationsProductIds.map(
          id => products?.find(p => p.id === Number(id))?.title
        );

  const tooltipText = productNames.join(', ');

  if (isLoading || !products) {
    return false;
  }

  return (
    <Tooltip title={tooltipText}>
      <Chip
        icon={<DataUsageIcon />}
        label={
          showLabel && `${productNames.length}/${products.length} products`
        }
      />
    </Tooltip>
  );
};

ReservationsChip.propTypes = {
  reservationsProductIds: array,
  reservationsProductNames: array,
  showLabel: bool,
};

export default ReservationsChip;
